export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    lastHourBid: 'Last Hour Bid'
};



// WEBPACK FOOTER //
// ./src/scenes/Adk5MinFactor/config.js